export const Color = {
    brand_green: "#ab192c",
    white: "#ffffff",
    black: "#000000",
    light_black: "#232323",
    dark_black: "#171717",
    grey: "#717171",
    pink: "#ff014f",
    orange: "#ff8a00",
    red: "#ff014f",
    dark_grey: "#161616",
    slate_grey: "#1e1e1e",
    soft_grey: "#303030",
    black_grey: "#0a0a0a",
    dark_green: "#001b01",
    black_green: "#001000",
    middle_grey: "#484848",
    smoke_grey: "#cacaca",
    lime_green: "#d2f800",
    silver_grey: "#5c5c5c",


    vip_yellow: "#f9c600",
    vip_purple: "#aa9aca",
    vip_blue: "#74adb3",

    yellow: "#ffff00",
    pear: "#d5ec37",
    inchWorm: "#7aec37",

    transparent: "transparent",

    scCards: "#12011A",
    roulBJ: "#071A01",
    vidPoker: "#000E24",
};